<template>
  <div class="header">
    <header :class="follow">
      <div class="st-Header_Inner">
        <h1 class="st-Hd_Logo">
          <router-link to="/">
            <img class="st-Hd_Logo_Img logo-img-navbar-coypright" :src="imgSrc">
          </router-link>
        </h1>
        <div class="st-Hd_Trigger">
          <div class="st-Hd_Trigger-bg"></div><a @click="hdTrigger($event)"></a>
        </div>
      </div>
    </header>
    <nav class="st-Nav" style="height: 100vh;">
      <div class="st-Nav_Inner">
        <div class="st-Nav_Link" style="">
          <ul class="st-Nav_List mb-0">

            <li class="st-Nav_List-trigger">
              <router-link to="/company/profile" class="company"><span class="st-Nav_List-en">
                  <font>
                    <font>COMPYANY</font>
                  </font>
                </span><span class="st-Nav_List-ja">
                  <font>
                    <font>企業情報</font>
                  </font>
                </span>
              </router-link>
            </li>
            <li class="st-Nav_List-trigger">
              <a class="st-Nav_List-link solution"><span class="st-Nav_List-en">
                  <font>
                    <font>SOLUTIONS</font>
                  </font>
                </span><span class="st-Nav_List-ja">
                  <font>
                    <font>ソリューションズ</font>
                  </font>
                </span>
                <i></i>
              </a>
              <div class="st-Nav_ListBox st-Nav_ListBox-recruit">
                <div class="m-auto">
                  <p class="st-Nav_ListBox-title">
                    <span class="st-Nav_ListBox-title-en">SOLUTIONS</span>
                    <span class="st-Nav_ListBox-title-ja">ソリューションズ</span>
                  </p>
                  <ul>
                    <li>
                      <router-link to="/solution/logistics-automation">
                        <picture><img src="../../../static/img/home/menu-logistics-automation.jpg" alt=""></picture>
                        <p>ロボティクス自動化ソリューション
                        </p>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/solution/low-code">
                        <picture><img src="../../../static/img/home/menu-low-code.jpg" alt=""></picture>
                        <p>Lowコードソリューション
                        </p>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="st-Nav_List-trigger">
              <router-link to="/service/index" class="service-index"><span class="st-Nav_List-en">
                  <font>
                    <font>SERVICE</font>
                  </font>
                </span><span class="st-Nav_List-ja">
                  <font>
                    <font>サービス案内</font>
                  </font>
                </span>
              </router-link>
            </li>
            <li class="st-Nav_List-trigger">
              <router-link to="/recruit/index" class="recruit-index"><span class="st-Nav_List-en">
                  <font>
                    <font>RECRUIT</font>
                  </font>
                </span><span class="st-Nav_List-ja">
                  <font>
                    <font>採用情報
                    </font>
                  </font>
                </span>
              </router-link>
            </li>

            <li class="st-Nav_List-trigger">
              <router-link to="/contact/index" class="contact-index"><span class="st-Nav_List-en">
                  <font>
                    <font>CONTACT US</font>
                  </font>
                </span><span class="st-Nav_List-ja">
                  <font>
                    <font>お問い合わせ</font>
                  </font>
                </span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<style />

<script type="text/javascript">
export default {
  props: ['follow', 'imgSrc'],
  data: function () {
    return {
      showSearchFlag: false,
      searchInput: ''
    }
  },
  mounted() {
    this.init()
    let mql = window.matchMedia('(max-width:768px)')
    if (mql.matches) {
      $('.st-Nav_List-link').on('click', function (t) {
        t.preventDefault()
        setTimeout(() => {
          $(this).toggleClass('is-open')
          $(this).next('.st-Nav_ListBox').slideToggle(300)
        }, 100)
      })
    }
  },
  methods: {
    hdTrigger(event) {
      let l = $('body')
      let a = $(event.currentTarget).parent()
      if (a.hasClass('is-active')) {
        a.removeClass('is-active')
        l.removeClass('is-sp-open')
        if (this.$route.path !== '/') { $('.st-Hd_Logo_Img').attr('src', '../../../static/img/logo/logo-black.png') }
        $('.st-Nav_List-en').css({ 'color': '#222' })
      } else {
        a.addClass('is-active')
        $('.st-Nav_List-en').css({ 'color': '#fff' })
        if (this.$route.path !== '/') $('.st-Hd_Logo_Img').attr('src', '../../../static/img/logo/logo-white.png')
        l.addClass('is-sp-open')
      }
    },
    init() {
      $('.st-Nav_SearchBox').bind('click', (e) => {
        let el = e || window.event
        let elem = el.target || el.srcElement
        while (elem) {
          if (elem.id && elem.id === 'searchBox-inner') {
            return
          }
          elem = elem.parentNode
        }
        $('.st-Nav_SearchBox').removeClass('is-active')
        this.showSearchFlag = false
      })
      $(document).scroll(() => {
        let viewW = $(window).width()
        if (viewW > 769) {
          setTimeout(() => {
            $('.st-Nav_SearchBox-inner').css({
              'height': $('.st-Header').height() + 3,
              'min-height': $('.st-Header').height() + 3
            })
          }, 200)
        } else {
          setTimeout(() => {
            $('.st-Nav_SearchBox-inner').css({
              'height': '0px',
              'min-height': '0px'
            })
          }, 200)
        }
      })
    },
    clickSearch() {

    },
    showSearchBox() {
      $('.st-Nav_SearchBox-inner').css({ 'height': $('.st-Header').height() + 3, 'min-height': $('.st-Header').height() + 3 })
      if (this.showSearchFlag === false) {
        $('.st-Nav_SearchBox').addClass('is-active')
        this.showSearchFlag = true
      } else {
        $('.st-Nav_SearchBox').removeClass('is-active')
        this.showSearchFlag = false
      }
    },
    closeSearchBox() {
      $('.st-Nav_SearchBox').removeClass('is-active')
      this.showSearchFlag = false
    },
    getTop() {
    }
  }
}
</script>

<style scoped>
.st-Nav_SearchBox-field {
  font-size: 28px;
  width: 78.8%;
}
.st-Nav_SearchBox-inner {
  min-height: 0px;
  height: 0px;
  border-bottom: 1px solid #ddd;
  transform: translate(0);
}
@media screen and (max-width: 769px) {
  .st-Nav_SearchBox-field {
    font-size: 1.6rem;
    height: 32px;
    line-height: 32px;
    width: 78.8%;
  }
  .st-Nav_SearchBox-inner {
    min-height: 0px !important;
    height: 0px !important;
    border-bottom: none;
    transform: translate(0);
  }
}
.home .st-Nav_Search {
  border-left: 1px solid #ddd;
  margin-bottom: 10px;
}
.st-Nav_List-trigger >>> img {
  height: 150px;
  object-fit: cover;
  background-color: transparent;
  width: 100%;
}

.st-Header {
  transition: height 0.2s ease-in-out;
}

.st-Nav_ListBox-title-en {
  font-family: acumin-pro-condensed, sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 2vw;
  line-height: 0.75em;
  letter-spacing: 0px;
  margin-bottom: 15px;
}

@media screen and (min-width: 769px) {
  .st-Nav_SearchBox {
    background-color: transparent;
  }

  .st-Nav_SearchBox-button {
    width: 46px;
    height: 46px;
    right: -10px;
    top: 20px;
  }

  .st-Nav_SearchBox-close {
    position: absolute;
    right: -60px !important;
    top: 10px !important;
    width: 36px !important;
    height: 36px !important;
  }
}

.st-Nav_SearchBox-close {
  position: absolute;
  right: 35px;
  top: 30px;
  width: 39px;
  height: 39px;
}

input {
  height: 32px;
  padding: 4px 0px;
  font-size: 12px;
}

.search-input-hull {
  width: 50px;
}

.search-input-hull >>> .el-input__inner:hover {
  border-color: transparent;
}

.search-input-hull >>> .el-input__inner:focus {
  border-color: transparent;
  outline: 0;
}

.search-input-hull >>> .el-input__inner {
  width: 42vw;
  border: 1px solid transparent;
  font-size: 30px;
}

a {
  border-bottom-style: none;
}

.st-Nav_List {
  width: calc(100% - 56px);
  max-width: 590px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.st-Nav_Search > a,
.st-Header_Inner > .st-Hd_Logo > a,
.st-Nav_List > .st-Nav_List-trigger > a {
  border-bottom-style: none;
}

.st-Hd_Logo a {
  display: contents;
}

.st-Nav_Search a {
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/navbar.vue